import { createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import moment from "moment";

export const dateSlice = createSlice({
  name: "date",
  initialState: {
    date:moment(new Date()).format("DD/MM/YY")
  },
  reducers: {
    setDate: (state, action) => {
      state.date = action.payload;
    },
  }
});

export const { setDate } = dateSlice.actions;
export default dateSlice;
